import React, { useState, useEffect } from "react";
import styles from "./join.module.scss";
import { getFunctionsHost } from "../../../utils/paths";
import { set } from "immutable";
import whatsappIcon from "../../images/whatsapp-icon.svg";
import loadingRipple from "../../images/loading-ripple.svg";
import { Branch, RegionLocationData } from "../locations/locations";

type location = {
  city: string;
  state: string;
  country: string;
  callingCode: string;
  coordinates?: {
    lat: number;
    lon: number;
  };
};

type LocationData = {
  location: location;
  whatsappGroups: {
    local: Array<Branch>;
    nearby: Array<Branch>;
  };
};



export default function Join() {
  const isMobileDevice = window.innerWidth < 600;

  const [locationData, setLocationData] = useState<Branch[] | null>(null);
  const [usLocationData, setUsLocationData] = useState<
    RegionLocationData[] | null
  >(null);
  const [isJoinButtonClicked, setIsJoinButtonClicked] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isUsaIp, setIsUsaIp] = useState(false);
  const [usStates, setUsStates] = useState<string[] | null>(null);
  const [selectedState, setSelectedState] = useState<string | null>(null);
  const [formUrl, setFormUrl] = useState("https://bit.ly/R4L-join");

  // Event handler for join button
  const handleJoinClick = async (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsJoinButtonClicked(true);
  };

  const handleStateSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedState(event.target.value);
  };

  useEffect(() => {
    async function getLocationData() {
      /**
       * 1 - Check browser support and user permissions for GPS
       * 2 - Get GPS based location data
       * 3 - Fallback to IP based location data
       * 4 - Special case for US - show states dropdown
       */
      setIsFetching(true);
      const userGps = await getUserGps();
      console.log("userGps", userGps);
      if (userGps) {
        const { latitude, longitude } = userGps.coords;
        const gpsLocationData = await getGpsLocationData(latitude, longitude);
        if (gpsLocationData) {
          setLocationData(mergeLocalAndNearby(gpsLocationData));
          setFormUrl(buildFormUrl(gpsLocationData.location));
          setIsFetching(false);
        }
      } else {
        const ipLocationData = await getIpBasedLocationData();
        if (ipLocationData) {
          if (ipLocationData.location.country == "United States") {
            const userState = ipLocationData.location.state;
            const usStatesLocationData = await getUsStatesLocationData();
            setUsLocationData(usStatesLocationData);
            setFormUrl(
              buildFormUrl({
                country: "United States",
                callingCode: "1",
              })
            );
            const foundUsStates = usStatesLocationData
              .map((stateGroup: RegionLocationData) => stateGroup.state ?? "")
              .sort((a: string, b: string) => a.localeCompare(b));

            setIsUsaIp(true);
            setUsStates(foundUsStates);
            if (foundUsStates.includes(userState)) setSelectedState(userState);
            setIsFetching(false);
            // getDataForStates(userCountry);
          } else {
            setLocationData(mergeLocalAndNearby(ipLocationData));
            setFormUrl(buildFormUrl(ipLocationData.location));
            setIsFetching(false);
          }
        }
      }
    }
    if (isJoinButtonClicked) {
      getLocationData();
    }
  }, [isJoinButtonClicked]);

  // useEffect(() => {
  //   console.log("------------");
  //   console.log("locationData", locationData);
  //   console.log("isFetching", isFetching);
  //   console.log("isUsaIp", isUsaIp);
  //   console.log("usStates", usStates);
  //   console.log("selectedState", selectedState);
  // }, [locationData, isUsaIp, isFetching, usStates, selectedState]);

  return (
    <section className={styles.join}>
      <div className="contentContainer">
        {!isJoinButtonClicked && (
          <button className={styles.joinButton} onClick={handleJoinClick}>
            {isFetching ? "Loading..." : "Find a group near you"}
          </button>
        )}
        {isJoinButtonClicked && (
          <>
            <div className={styles.existingGroupsContainer}>
              <h3>
                <img src={whatsappIcon} alt="Whatsapp icon" />
                Join a group near you:
              </h3>
              {isFetching && <img src={loadingRipple} />}

              {isUsaIp && usLocationData && (
                <>
                  <select
                    className={styles.stateSelect}
                    onChange={handleStateSelectChange}
                  >
                    <option value="">Select a state</option>
                    {usStates &&
                      usStates.map((state, i) => (
                        <option
                          value={state}
                          key={i}
                          selected={selectedState == state}
                        >
                          {state}
                        </option>
                      ))}
                  </select>
                </>
              )}
              <div className={styles.existingGroupLinks}>
                {locationData && locationData.length == 0 && (
                  <div>No nearby groups found.</div>
                )}

                {isUsaIp &&
                  selectedState &&
                  usLocationData &&
                  (() => {
                    const foundGroup = usLocationData.find(
                      (group: RegionLocationData) =>
                        group.state === selectedState
                    );
                    if (!foundGroup) return null;

                  return foundGroup.groups.map((group: Branch, i: number) => (
                      <a
                        className={styles.joinGroupLink}
                        href={group.group_url}
                        target="join"
                        key={i}
                      >
                        {(group.label && group.label != "") ? group.label : group.city}
                      </a>
                    ));
                  })()}

                {!isUsaIp &&
                  locationData &&
                  locationData.map((group: Branch, i: number) => (
                    <a
                      className={styles.joinGroupLink}
                      href={group.group_url}
                      target="join"
                      key={i}
                    >
                      {group.label}
                    </a>
                  ))}
              </div>
              <div className={styles.noGroupFound}>
                <span>No group in your area?</span>
                <a
                  className={styles.joinOtherLocation}
                  href={formUrl}
                  target="join"
                >
                  Get notified when a group opens
                </a>
                <span>Or</span>
                <a href="/lead">Learn about starting a group</a>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
}

async function getUserGps(): Promise<any> {
  let userGps:GeolocationPosition|null = null;
  if (navigator.geolocation) {
    try {
      userGps = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve(position);
          },
          (error) => {
            reject(error);
          }
        );
      });
    } catch (err) {
      console.error(err);
    }
  }
  console.log("userGps", userGps);
  //TODO: Declare a type based on console.log
  return userGps;
}

async function getGpsLocationData(
  lat: number,
  lon: number
): Promise<LocationData> {
  const requestPath = `${getFunctionsHost()}getGpsBasedLocationData?lat=${lat}&lon=${lon}`;
  console.log("requestPath", requestPath);
  const res = await fetch(requestPath);
  const data = await res.json();
  return data;
}

async function getIpBasedLocationData(): Promise<LocationData> {
  const requestPath = `${getFunctionsHost()}getIpBasedLocationData`;
  const res = await fetch(requestPath);
  const data = await res.json();
  return data;
}

async function getUsStatesLocationData(): Promise<RegionLocationData[]> {
  const requestPath = `${getFunctionsHost()}getAllWhatsappGroups`;
  const res = await fetch(requestPath);
  const data = await res.json();
  const stateGroups = data.filter(
    (countryGroup: any) => countryGroup.country == "United States"
  );
  return stateGroups;
}

function mergeLocalAndNearby(locationData: LocationData): Branch[] {
  const localGroups = locationData.whatsappGroups.local;
  const nearbyGroups = locationData.whatsappGroups.nearby;
  const mergedGroups = localGroups.concat(nearbyGroups);
  return mergedGroups;
}

function buildFormUrl(location: any): string {
  const params = new URLSearchParams({
    usp: "pp_url",
    "entry.209346782": location.country ?? "",
    "entry.182952375": location.state ?? "",
    "entry.1302588749": location.city ?? "",
    "entry.723098138": location.callingCode ? `${location.callingCode}-` : "",
  });
  let url = `https://docs.google.com/forms/d/e/1FAIpQLSdYXcjCh8TvSG3Z1Ey-jIBNfAs3e7sGHWt7qxmRlXyi5mUn3g/viewform?${params}`;
  encodeURIComponent(location.callingCode);
  if (location.country == "Israel") {
    url =
      "https://docs.google.com/forms/d/e/1FAIpQLSdytRdBxVAbOlsZVfCQ_MDwgZhOu6wwPLC1DUBpjLUbD8HgwA/viewform";
  }
  return url;
}
